export default __webpack_public_path__ + "fe6c0a47819466fa434b21f0f5b63d9a.png";